import type { TenantSlug } from "@/hooks/useTenant";

export const BASE_DOCUMENT_TITLE = "ATMS | Aurora Transportation Management";

const ENV_TITLE_PREFIX: Record<TenantSlug, string | null> = {
  dev: "Dev",
  staging: "Stg",
  "pre-prod": "Pre-Prod",
  prod: null,
};

/** Build the browser tab title for a given environment/tenant slug. */
export function buildDocumentTitle(slug: TenantSlug): string {
  const prefix = ENV_TITLE_PREFIX[slug] ?? null;
  return prefix ? `${prefix} | ${BASE_DOCUMENT_TITLE}` : BASE_DOCUMENT_TITLE;
}
